import { render, staticRenderFns } from "./ClientGeolocCard.vue?vue&type=template&id=e220358a"
import script from "./ClientGeolocCard.vue?vue&type=script&lang=js"
export * from "./ClientGeolocCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports